import React, { useState, useEffect } from 'react';

const VisualizationAccordion = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // Move visualization buttons outside the black container
  useEffect(() => {
    if (activeIndex !== null) {
      setTimeout(() => {
        const wrapper = document.getElementById(`viz-wrapper-${activeIndex}`);
        const buttonContainer = document.getElementById(`viz-buttons-${activeIndex}`);

        if (wrapper && buttonContainer) {
          // Clear any existing buttons first
          buttonContainer.innerHTML = '';

          // Find all .row elements with buttons inside the visualization
          const rows = wrapper.querySelectorAll('.row');
          rows.forEach(row => {
            const buttons = row.querySelectorAll('button');
            if (buttons.length > 0) {
              // Move actual buttons (not clones) to preserve event listeners
              buttons.forEach(button => {
                buttonContainer.appendChild(button);
              });
            }
          });
        }
      }, 100);
    }
  }, [activeIndex]);

  const handleLinkClick = (e, link) => {
    // For external GitHub links, let the browser handle it
    if (link && link.startsWith('/github-')) {
      // Link component will handle the redirect via App.js routes
      return;
    }
  };

  return (
    <div className="visualization-accordion">
      {data.map((item, index) => (
        <div key={index} className="accordion-item">
          <button
            className={`accordion-header ${activeIndex === index ? 'active' : ''}`}
            onClick={() => toggleAccordion(index)}
          >
            <div className="accordion-header-content">
              <h3 className="accordion-title">{item.title}</h3>
              <p className="accordion-subtitle">
                {item.subtitle}
              </p>
            </div>
            <span className="accordion-icon">{activeIndex === index ? '−' : '+'}</span>
          </button>

          {activeIndex === index && (
            <div className="accordion-content">
              {/* Show text content outside visualization */}
              {item.text && (
                <div className="accordion-text">
                  <p>{item.text}</p>
                </div>
              )}

              {/* Show visualization in its own contained viewer */}
              {item.graph && (
                <div className="visualization-viewer">
                  <div className="visualization-wrapper" id={`viz-wrapper-${index}`}>
                    {item.graph}
                  </div>
                </div>
              )}

              {/* Show interaction hint and buttons below visualization */}
              <div className="accordion-bottom-controls">
                <div className="bottom-left-controls">
                  {item.link && (
                    <a
                      href={item.link}
                      className="btn-code"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => handleLinkClick(e, item.link)}
                    >
                      {item.button}
                    </a>
                  )}
                </div>

                <div className="bottom-right-controls" id={`viz-buttons-${index}`}>
                  {/* Visualization buttons will be moved here via CSS */}
                </div>

                {item.interaction && (
                  <p className="interaction-hint">
                    <strong>💡 {item.interaction}</strong>
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default VisualizationAccordion;
